import React from "react";
import { Box, Tabs, Tab, Divider } from "@mui/material";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import CustomTabsV2 from "../../Components/CustomTabs";
import GetAudioApproval from "./GetAudioApproval";
import WhatsAppMessagePreview from "../../Components/WhatsAppMessagePreview";
import TextMessageTemplatePreview from "../../Components/TextMessageTemplatePreview";

const GetMediaApproval = () => {
  const tabs = [
    { label: "Voice", to: "audio", content: <GetAudioApproval /> },
    {
      label: "Whatsapp",
      to: "template",
      content: <WhatsAppMessagePreview />,
    },
    {
      label: "SMS",
      to: "text-template",
      content: <TextMessageTemplatePreview />,
    },
  ];

  return (
    <>
      <div id="main-wrapper">
        <Header />
        <Sidebar />
        <div className="content-body" style={{ height: "100vh", overflowX: "hidden", overflowY: "hidden" }}>
          <div className="page-titles" style={{ marginBottom: window.innerWidth <= 768 ? "10px" : "15px" }}>
            <ol className="breadcrumb">
              <li>
                <h5 className="bc-title">Get Media Approval</h5>
              </li>
              <li className="breadcrumb-item">
                <a href="javascript:void(0)">Home</a>
              </li>
              <li className="breadcrumb-item active">
                <a href="javascript:void(0)">Get Media Approval</a>
              </li>
            </ol>
          </div>

          <div className="col-12 bst-seller" style={{ 
            padding: window.innerWidth <= 576 ? "5px 10px" : window.innerWidth <= 992 ? "5px 15px" : "0px 15px",
            maxWidth: "100%",
            overflowX: "hidden",
            height: "calc(100vh - 140px)", // Account for header and breadcrumb
          }}>
            <div className="card" style={{ overflowX: "hidden", height: "100%" }}>
              <CustomTabsV2 tabs={tabs} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GetMediaApproval;
